// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FNhh1","main":"styles_main__Y7g2S"};